<template>
  <div class="projects-list-container">
         <!-- 左侧蓝色标记和标题 -->
     <div class="page-header">
       <div class="blue-bar"></div>
       <h2 class="page-title">下级机构管理</h2>
       <el-button @click="handleBack" icon="el-icon-back" size="small">返回我的机构</el-button>
     </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <div class="search-inputs">
                 <div class="search-item">
           <el-input
             v-model="searchForm.projectName"
             placeholder="项目部名称"
             prefix-icon="el-icon-search"
             clearable
           ></el-input>
         </div>
         
         <!-- <div class="search-item">
           <el-cascader
             v-model="searchForm.region"
             :options="regionOptions"
             :props="regionProps"
             placeholder="选择省市区"
             clearable
             style="width: 200px;"
           ></el-cascader>
         </div> -->

        <div class="search-item">
          <el-input
            v-model="searchForm.managerName"
            placeholder="项目经理"
            clearable
          ></el-input>
        </div>
        
        <div class="search-item">
          <el-input
            v-model="searchForm.materialManagerName"
            placeholder="材料经理"
            clearable
          ></el-input>
        </div>
                 <div class="search-buttons">
           <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
           <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
           <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增下级机构</el-button>
         </div>
      </div>
    </div>
    
    <!-- 表格区域 -->
    <div class="table-container">
      <el-table
        :data="projectsList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
      >
         <el-table-column label="项目部名称" prop="projectName" min-width="180" fixed="left" show-overflow-tooltip>
           <template slot-scope="scope">
             <el-link type="primary" @click="handleView(scope.row)">{{ scope.row.projectName }}</el-link>
           </template>
         </el-table-column>
         
                   <el-table-column label="项目地址" prop="projectAddress" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="address-display">
                <div v-if="scope.row.provinceName || (scope.row.region && scope.row.region.length > 0)" class="region-info">
                  <span class="region-text">{{ getDisplayAddress(scope.row) }}</span>
                </div>
                <div v-else class="address-text">{{ scope.row.projectAddress || '-' }}</div>
              </div>
            </template>
          </el-table-column>
         
         <el-table-column label="项目金额" prop="projectScale" width="130">
           <template slot-scope="scope">
             <span v-if="scope.row.projectScale">{{ formatNumber(scope.row.projectScale) }}</span>
             <span v-else>-</span>
           </template>
         </el-table-column>
         
         <el-table-column label="项目经理" prop="managerName" width="110">
           <template slot-scope="scope">
             {{ maskName(scope.row.managerName) }}
           </template>
         </el-table-column>
         
         <el-table-column label="联系方式" prop="managerContact" width="130">
           <template slot-scope="scope">
             {{ maskPhone(scope.row.managerContact) }}
           </template>
         </el-table-column>
         
         <el-table-column label="材料经理" prop="materialManagerName" width="110">
           <template slot-scope="scope">
             {{ maskName(scope.row.materialManagerName) }}
           </template>
         </el-table-column>
         
         <el-table-column label="材料经理联系方式" prop="materialManagerContact" width="150">
           <template slot-scope="scope">
             {{ maskPhone(scope.row.materialManagerContact) }}
           </template>
         </el-table-column>
         
                  <el-table-column label="所属单位" prop="unitInfo.unitName" width="160" show-overflow-tooltip></el-table-column>
         
         <el-table-column label="创建时间" prop="createTime" width="170">
           <template slot-scope="scope">
             <span>{{ formatDateTime(scope.row.createTime) }}</span>
           </template>
         </el-table-column>
         
                   <el-table-column label="项目简称" prop="projectShortName" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.projectShortName || '-' }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="简称首字母" prop="shortNameInitial" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.shortNameInitial || '-' }}</span>
            </template>
          </el-table-column>
         
         <el-table-column label="状态" prop="status" width="110">
           <template slot-scope="scope">
             <el-tag :type="getStatusType(scope.row.status)">
               {{ getStatusText(scope.row.status) }}
             </el-tag>
           </template>
         </el-table-column>
         
                   <el-table-column label="操作" width="240" fixed="right">
           <template slot-scope="scope">
             <el-button
               size="mini"
               type="text"
               @click="handleView(scope.row)"
             >查看</el-button>
             <el-button
               size="mini"
               type="text"
               @click="handleEdit(scope.row)"
             >编辑</el-button>
             <el-button
               size="mini"
               type="text"
               @click="handleProjectUsers(scope.row)"
             >项目用户</el-button>
             <el-button
               size="mini"
               type="text"
               class="delete-btn"
               @click="handleDelete(scope.row)"
             >删除</el-button>
           </template>
         </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page + 1"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    
    <!-- 项目编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :show-close="true"
      center
      class="project-dialog"
    >
             <el-form
         :model="projectForm"
         :rules="projectRules"
         ref="projectForm"
         label-position="top"
       >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目部名称" prop="projectName">
              <el-input v-model="projectForm.projectName" placeholder="请输入项目部名称"></el-input>
            </el-form-item>
          </el-col>
                     <el-col :span="12">
             <el-form-item label="所属单位">
               <el-input v-model="currentUnitName" disabled style="width: 100%"></el-input>
             </el-form-item>
           </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目经理" prop="managerName">
              <el-autocomplete
                v-model="projectForm.managerName"
                :fetch-suggestions="queryManagerUsers"
                placeholder="请输入项目经理姓名"
                :trigger-on-focus="false"
                value-key="username"
                @select="handleManagerSelect"
                style="width: 100%"
              >
                <template slot-scope="{ item }">
                  <div class="user-option">
                    <span class="user-name">{{ item.username }}</span>
                    <span class="user-phone">{{ item.phone || '-' }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
                     <el-col :span="12">
             <el-form-item label="联系方式" prop="managerContact">
               <el-input v-model="projectForm.managerContact" placeholder="请输入手机号码"></el-input>
             </el-form-item>
           </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="材料经理" prop="materialManagerName">
              <el-autocomplete
                v-model="projectForm.materialManagerName"
                :fetch-suggestions="queryMaterialManagerUsers"
                placeholder="请输入材料经理姓名"
                :trigger-on-focus="false"
                value-key="username"
                @select="handleMaterialManagerSelect"
                style="width: 100%"
              >
                <template slot-scope="{ item }">
                  <div class="user-option">
                    <span class="user-name">{{ item.username }}</span>
                    <span class="user-phone">{{ item.phone || '-' }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
                     <el-col :span="12">
             <el-form-item label="材料经理联系方式" prop="materialManagerContact">
               <el-input v-model="projectForm.materialManagerContact" placeholder="请输入材料经理手机号码"></el-input>
             </el-form-item>
           </el-col>
        </el-row>
        
                 <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="项目金额" prop="projectScale">
               <el-input-number
                 v-model="projectForm.projectScale"
                 :min="0"
                 :precision="2"
                 :step="1000"
                 :max="999999999999.99"
                 placeholder="请输入项目金额"
                 style="width: 100%"
               ></el-input-number>
             </el-form-item>
           </el-col>
           
         </el-row>
        
                 <el-form-item label="项目地址" prop="projectAddress">
           <div class="address-container">
             <div class="region-selector">
               <el-cascader
                 v-model="projectForm.region"
                 :options="regionOptions"
                 :props="regionProps"
                 placeholder="请选择省市区"
                 clearable
                 style="width: 100%; margin-bottom: 10px;"
               ></el-cascader>
             </div>
             <div class="detail-address">
               <el-input
                 v-model="projectForm.detailAddress"
                 type="textarea"
                 :rows="2"
                 :maxlength="200"
                 show-word-limit
                 placeholder="请输入详细地址"
               ></el-input>
             </div>
             <!-- 地址预览 -->
             <div v-if="addressPreview" class="address-preview">
               <span class="preview-label">地址预览：</span>
               <span class="preview-content">{{ addressPreview }}{{ projectForm.detailAddress || '' }}</span>
             </div>
           </div>
         </el-form-item>
         
         <!-- 项目简称和简称首字母 -->
         <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="项目简称">
               <el-input
                 v-model="projectForm.projectShortName"
                 placeholder="请输入项目简称（6字符以内）"
                 maxlength="6"
                 show-word-limit
               ></el-input>
             </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="简称首字母">
               <el-input
                 v-model="projectForm.shortNameInitial"
                 placeholder="请输入简称首字母（6字符以内）"
                 maxlength="6"
                 show-word-limit
               ></el-input>
             </el-form-item>
           </el-col>
         </el-row>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 项目详情对话框 -->
    <el-dialog
      title="项目详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :show-close="true"
      center
    >
      <div v-if="currentProject" class="project-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="项目名称">{{ currentProject.projectName }}</el-descriptions-item>
          <el-descriptions-item label="所属单位">{{ currentProject.unitInfo?.unitName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="项目经理">{{ maskName(currentProject.managerName) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ maskPhone(currentProject.managerContact) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="材料经理">{{ maskName(currentProject.materialManagerName) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="材料经理联系方式">{{ maskPhone(currentProject.materialManagerContact) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="项目金额">
            {{ currentProject.projectScale ? formatNumber(currentProject.projectScale) : '-' }}
          </el-descriptions-item>
          
          <el-descriptions-item label="创建时间">{{ formatDateTime(currentProject.createTime) }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStatusType(currentProject.status)">
              {{ getStatusText(currentProject.status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="项目地址" :span="2">
            <div v-if="currentProject.provinceName || (currentProject.region && currentProject.region.length > 0)">
              {{ getDisplayAddress(currentProject) }}
            </div>
            <div v-else>{{ currentProject.projectAddress || '-' }}</div>
          </el-descriptions-item>
          
                     <el-descriptions-item label="项目简称">{{ currentProject.projectShortName || '-' }}</el-descriptions-item>
           <el-descriptions-item label="简称首字母">{{ currentProject.shortNameInitial || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  searchProjects, 
  createProject, 
  updateProject, 
  deleteProject
} from '@/api/modules/projects.js'

// 导入用户查询API
import { query_users_pagination, save_user } from '@/api/modules/user.js'

// 导入省市区工具函数
import { 
  getRegionOptions, 
  getFullAddress,
  getCascaderProps,
  getRegionNameByCode
} from '@/utils/regions'

// 导入脱敏工具函数
import { maskName as maskNameUtil, maskPhone as maskPhoneUtil } from '@/utils/mask.js'

export default {
  name: 'ProjectsList',
  data() {
    return {
      loading: false,
      saving: false,
      
             // 搜索表单
       searchForm: {
         projectName: '',
         region: [],
         managerName: '',
         materialManagerName: '' // 新增材料经理搜索字段
       },
      
      // 项目列表
      projectsList: [],
      
      // 分页信息
      pagination: {
        page: 0,
        size: 10,
        total: 0
      },
      
             // 当前用户单位信息
       currentUnitId: null,
       currentUnitName: '',
      
      // 对话框相关
      dialogVisible: false,
      detailDialogVisible: false,
      dialogTitle: '新增项目',
      isEdit: false,
      
             // 项目表单
       projectForm: {
         projectName: '',
         projectAddress: '',
         region: [], // 省市区级联选择（用于前端显示）
         detailAddress: '', // 详细地址
         projectScale: null,
         managerName: '',
         managerContact: '',
         materialManagerName: '', // 材料经理姓名
         materialManagerContact: '', // 材料经理联系方式
         remark: '' // 备注字段
       },
      
      // 表单验证规则
      projectRules: {
                 projectName: [
           { required: true, message: '请输入项目名称', trigger: 'blur' },
           { min: 2, max: 200, message: '项目名称长度在 2 到 200 个字符', trigger: 'blur' }
         ],
                 managerName: [
           { required: true, message: '请输入项目经理姓名', trigger: 'blur' },
           { 
             validator: (rule, value, callback) => {
               if (!value) {
                 callback()
                 return
               }
               const trimmedValue = value.trim()
               if (trimmedValue.length < 2) {
                 callback(new Error('项目经理姓名长度至少为 2 个字符'))
               } else if (trimmedValue.length > 50) {
                 callback(new Error('项目经理姓名长度不能超过 50 个字符'))
               } else {
                 callback()
               }
             }, 
             trigger: 'blur' 
           }
         ],
         managerContact: [
           { required: true, message: '请输入联系方式', trigger: 'blur' },
           { 
             pattern: /^1[3-9]\d{9}$/, 
             message: '请输入正确的手机号码格式', 
             trigger: 'blur' 
           }
         ],
         materialManagerName: [
           { required: false, message: '请输入材料经理姓名', trigger: 'blur' },
           { 
             validator: (rule, value, callback) => {
               if (!value || value.trim() === '') {
                 callback()
                 return
               }
               const trimmedValue = value.trim()
               if (trimmedValue.length < 2) {
                 callback(new Error('材料经理姓名长度至少为 2 个字符'))
               } else if (trimmedValue.length > 50) {
                 callback(new Error('材料经理姓名长度不能超过 50 个字符'))
               } else {
                 callback()
               }
             }, 
             trigger: 'blur' 
           }
         ],
         materialManagerContact: [
           { required: false, message: '请输入材料经理联系方式', trigger: 'blur' },
           { 
             pattern: /^1[3-9]\d{9}$/, 
             message: '请输入正确的手机号码格式', 
             trigger: 'blur' 
           }
         ],
         region: [
           { 
             required: true, 
             message: '请选择省市区', 
             trigger: 'change',
             validator: (rule, value, callback) => {
               if (!value || value.length < 3) {
                 callback(new Error('请选择完整的省市区'))
               } else {
                 callback()
               }
             }
           }
         ],
         detailAddress: [
           { required: true, message: '请输入详细地址', trigger: 'blur' },
           { max: 200, message: '详细地址不能超过200个字符', trigger: 'blur' }
         ]
      },
      
      // 当前选中的项目
      currentProject: null,
      
      // 省市区数据
      regionOptions: [],
      regionProps: getCascaderProps(),
      
      // 地址预览
      addressPreview: ''
    }
  },
  
     created() {
this.getCurrentUnitInfo()
     this.initRegionData()
     this.fetchProjects()
},
   
   watch: {
     // 监听省市区选择变化，更新地址预览
     'projectForm.region': {
       handler(newVal) {
         if (newVal && newVal.length >= 3) {
           const provinceName = getRegionNameByCode(newVal[0])
           const cityName = getRegionNameByCode(newVal[1])
           const districtName = getRegionNameByCode(newVal[2])
           
           // 处理直辖市情况：如果省和市名字一样，只显示一个
           if (provinceName === cityName) {
             this.addressPreview = (provinceName || '') + (districtName || '')
           } else {
             this.addressPreview = (provinceName || '') + (cityName || '') + (districtName || '')
           }
           
} else {
           this.addressPreview = ''
         }
       },
       deep: true
     },
     
     // 监听详细地址变化，更新地址预览
     'projectForm.detailAddress': {
       handler(newVal) {
         // 重置地址预览，重新计算完整地址
         if (this.projectForm.region && this.projectForm.region.length >= 3) {
           const provinceName = getRegionNameByCode(this.projectForm.region[0])
           const cityName = getRegionNameByCode(this.projectForm.region[1])
           const districtName = getRegionNameByCode(this.projectForm.region[2])
           
           // 处理直辖市情况
           if (provinceName === cityName) {
             this.addressPreview = (provinceName || '') + (districtName || '')
           } else {
             this.addressPreview = (provinceName || '') + (cityName || '') + (districtName || '')
           }
           
           if (newVal) {
             this.addressPreview += newVal
           }
           
}
       }
     }
   },
  
     methods: {
     // 返回我的机构页面
     handleBack() {
       this.$router.push('/basic/unit-info')
     },
     
          // 获取当前用户单位信息
      getCurrentUnitInfo() {
       try {
         const userInfo = this.$store.state.userInfo || {}
         if (userInfo.unitId) {
           this.currentUnitId = userInfo.unitId
           this.currentUnitName = userInfo.unitName || '当前单位'
} else {
           console.warn('未能从用户信息中获取unitId')
           this.$message.error('无法获取当前单位信息，请重新登录')
         }
       } catch (err) {
         console.error('获取用户单位信息出错:', err)
         this.$message.error('获取单位信息失败')
       }
     },
    
    // 获取项目列表
    async fetchProjects() {
try {
        this.loading = true
        
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          size: this.pagination.size,
          sortBy: 'createTime',
          sortDir: 'desc'
        }
        
        // 限制只查询当前单位下面的项目
        if (this.currentUnitId) {
          params.unitInfoId = this.currentUnitId
} else {
          console.warn('当前单位ID未获取到，无法限制查询范围')
          this.$message.warning('无法获取当前单位信息，查询可能包含所有项目')
        }
        
        // 处理省市区搜索参数
        if (this.searchForm.region && this.searchForm.region.length > 0) {
          // 支持按省市区搜索
          if (this.searchForm.region.length >= 1) {
            params.provinceCode = this.searchForm.region[0]
          }
          if (this.searchForm.region.length >= 2) {
            params.cityCode = this.searchForm.region[1]
          }
          if (this.searchForm.region.length >= 3) {
            params.districtCode = this.searchForm.region[2]
          }
        }
const response = await searchProjects(params)
if (response.data && response.data.success) {
           const data = response.data.data
           this.projectsList = data.content || []
           this.pagination.total = data.totalElements || 0
         } else {
          console.warn('项目列表响应格式不正确:', response)
          this.$message.error(response.data?.message || '获取项目列表失败')
        }
      } catch (error) {
        console.error('获取项目列表失败:', error)
        this.$message.error('获取项目列表失败')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.page = 0
      this.fetchProjects()
    },
    
         // 重置搜索
     handleReset() {
       this.searchForm = {
         projectName: '',
         region: [],
         managerName: '',
         materialManagerName: ''
       }
       this.pagination.page = 0
       this.fetchProjects()
     },
    
         // 新增项目
     handleAdd() {
       this.isEdit = false
       this.dialogTitle = '新增项目'
       this.projectForm = {
         projectName: '',
         projectAddress: '',
         region: [],
         detailAddress: '',
         projectScale: null,
         managerName: '',
         managerContact: '',
         materialManagerName: '',
         materialManagerContact: '',
         remark: ''
       }
       
       // 重置地址预览
       this.addressPreview = ''
       
this.dialogVisible = true
     },
    
         // 编辑项目
     handleEdit(row) {
       this.isEdit = true
       this.dialogTitle = '编辑项目'
       
// 从后台数据构建省市区选择数组
       let region = []
       if (row.provinceCode && row.cityCode && row.districtCode) {
         region = [row.provinceCode, row.cityCode, row.districtCode]
}
       
       this.projectForm = {
         id: row.id,
         projectName: row.projectName,
         projectAddress: row.projectAddress,
         region: region,
         detailAddress: row.detailAddress || '',
         projectScale: row.projectScale,
         managerName: row.managerName,
         managerContact: row.managerContact,
         materialManagerName: row.materialManagerName || '',
         materialManagerContact: row.materialManagerContact || '',
         remark: row.remark || ''
       }
       
this.dialogVisible = true
     },
    
    // 查看项目详情
    handleView(row) {
      this.currentProject = row
      this.detailDialogVisible = true
    },
    
         // 删除项目
     handleDelete(row) {
       this.$confirm('确定要删除该项目吗？', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(async () => {
         try {
           const response = await deleteProject(row.id)
           if (response.data && response.data.success) {
             this.$message.success('删除成功')
             this.fetchProjects()
           } else {
             this.$message.error(response.data?.message || '删除失败')
           }
         } catch (error) {
           console.error('删除项目失败:', error)
           this.$message.error('删除项目失败')
         }
       }).catch(() => {})
     },
     
     // 跳转到项目用户管理
     handleProjectUsers(row) {
// 将项目信息存储到 sessionStorage，供项目用户管理页面使用
       sessionStorage.setItem('currentProjectInfo', JSON.stringify({
         id: row.id,
         projectName: row.projectName,
         provinceName: row.provinceName,
         cityName: row.cityName,
         districtName: row.districtName,
         detailAddress: row.detailAddress,
         unitInfoId: row.unitInfoId,
         unitInfo: row.unitInfo
       }))
       
       // 跳转到现有的项目用户管理页面
       this.$router.push('/basic/project-user-info')
     },
    
         // 保存项目
     async handleSave() {
       try {
         const valid = await this.$refs.projectForm.validate()
         if (!valid) return
         
         this.saving = true
         
                   // 准备提交数据，自动设置当前用户单位ID和用户ID
         // 获取当前用户ID，支持多种可能的字段名
         let currentUserId = null
         const userInfo = this.$store.state.userInfo || {}
         
         // 尝试多种可能的用户ID字段
         if (userInfo.id) {
           currentUserId = userInfo.id
         } else if (userInfo.userId) {
           currentUserId = userInfo.userId
         } else if (userInfo.uid) {
           currentUserId = userInfo.uid
         } else if (userInfo.user_id) {
           currentUserId = userInfo.user_id
         }
         
         // 调试日志
const submitData = {
           ...this.projectForm,
           unitInfoId: this.currentUnitId,
           currentUserId: currentUserId
         }
         
                   // 将省市区级联选择转换为后台需要的格式
         if (this.projectForm.region && this.projectForm.region.length >= 3) {
           // 获取省市区代码和名称
           const provinceCode = this.projectForm.region[0]
           const cityCode = this.projectForm.region[1]
           const districtCode = this.projectForm.region[2]
           
           const provinceName = getRegionNameByCode(provinceCode)
           const cityName = getRegionNameByCode(cityCode)
           const districtName = getRegionNameByCode(districtCode)
           
// 设置后台需要的字段
           submitData.provinceCode = provinceCode
           submitData.provinceName = provinceName
           submitData.cityCode = cityCode
           submitData.cityName = cityName
           submitData.districtCode = districtCode
           submitData.districtName = districtName
           
           // 合并完整地址（处理直辖市情况）
           let fullAddress = ''
           if (provinceName === cityName) {
             // 直辖市：省和市名字一样，只显示一个
             fullAddress = (provinceName || '') + (districtName || '')
           } else {
             fullAddress = (provinceName || '') + (cityName || '') + (districtName || '')
           }
           
           if (this.projectForm.detailAddress) {
             fullAddress += this.projectForm.detailAddress
           }
           
           submitData.projectAddress = fullAddress
} else {
           // 如果没有选择完整的省市区，只保存详细地址
           submitData.projectAddress = this.projectForm.detailAddress || ''
}
         
         let response
         if (this.isEdit) {
           response = await updateProject(this.projectForm.id, submitData)
         } else {
           response = await createProject(submitData)
         }
         
         if (response.data && response.data.success) {
           const projectId = response.data.data?.id || this.projectForm.id
           
           // 如果选择了项目经理，将项目经理和项目做关联
           if (this.projectForm.managerName && projectId) {
             await this.associateManagerWithProject(this.projectForm.managerName, projectId)
           }
           
           this.$message.success(this.isEdit ? '更新成功' : '创建成功')
           this.dialogVisible = false
           this.fetchProjects()
         } else {
           this.$message.error(response.data?.message || '操作失败')
         }
       } catch (error) {
         console.error('保存项目失败:', error)
         this.$message.error('保存项目失败')
       } finally {
         this.saving = false
       }
     },
    
    // 对话框关闭
    handleDialogClose() {
      this.$refs.projectForm?.resetFields()
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.page = 0
      this.fetchProjects()
    },
    
    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.page = page - 1
      this.fetchProjects()
    },
    
    // 格式化数字
    formatNumber(value) {
      if (!value) return '-'
      return new Intl.NumberFormat('zh-CN').format(value)
    },
    
    // 格式化日期时间
    formatDateTime(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('zh-CN')
    },
    
    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        'ACTIVE': 'success',
        'INACTIVE': 'info',
        'COMPLETED': 'warning',
        'CANCELLED': 'danger'
      }
      return statusMap[status] || 'info'
    },
    
         // 获取状态文本
     getStatusText(status) {
       const statusMap = {
         'ACTIVE': '进行中',
         'INACTIVE': '未开始',
         'COMPLETED': '已完成',
         'CANCELLED': '已取消'
       }
       return statusMap[status] || '未知'
     },
     
     // 初始化省市区数据
     initRegionData() {
       // 使用工具函数获取省市区数据
       this.regionOptions = getRegionOptions()
},
     
     // 根据代码获取地区名称
     getRegionNameByCode(code) {
       const findRegion = (regions, targetCode) => {
         for (const region of regions) {
           if (region.code === targetCode) {
             return region.name
           }
           if (region.children) {
             const found = findRegion(region.children, targetCode)
             if (found) return found
           }
         }
         return null
       }
       return findRegion(this.regionOptions, code)
     },
     
           // 获取显示的地址
      getDisplayAddress(row) {
// 优先使用新的省市区字段
        if (row.provinceName && row.cityName && row.districtName) {
          let address = ''
          
          // 处理直辖市情况：如果省和市名字一样，只显示一个
          if (row.provinceName === row.cityName) {
            address = row.provinceName + row.districtName
} else {
            address = row.provinceName + row.cityName + row.districtName
}
          
          // 添加详细地址
          if (row.detailAddress) {
            address += row.detailAddress
}
          
return address
        }
        
        // 兼容旧的region字段
        if (row.region && row.region.length > 0) {
          const oldAddress = getFullAddress(row.region, row.detailAddress)
return oldAddress
        }
        
        // 最后使用projectAddress字段
return row.projectAddress || '-'
      },
      
      // 查询项目经理用户（非超级管理员）
      async queryManagerUsers(queryString, cb) {
        try {
          // 如果没有输入，返回空列表
          if (!queryString || queryString.trim() === '') {
            cb([])
            return
          }
          
          const params = {
            username: queryString.trim(),
            page: 0,
            size: 50,
            sortBy: 'id',
            sortDir: 'asc'
          }
          
          const response = await query_users_pagination(params)
          
          if (response.data && response.data.success) {
            const users = response.data.data?.content || []
            // 过滤掉 roleId 为 1 的超级管理员，并确保用户名包含查询字符串
            const filteredUsers = users.filter(user => {
              // 排除超级管理员
              if (user.roleId === 1) {
                return false
              }
              // 确保用户名匹配（不区分大小写）
              if (queryString && user.username) {
                return user.username.toLowerCase().includes(queryString.toLowerCase())
              }
              return true
            })
            
            cb(filteredUsers)
          } else {
            cb([])
          }
        } catch (error) {
          console.error('查询项目经理用户失败:', error)
          cb([])
        }
      },
      
      // 查询材料经理用户（非超级管理员）
      async queryMaterialManagerUsers(queryString, cb) {
        try {
          // 如果没有输入，返回空列表
          if (!queryString || queryString.trim() === '') {
            cb([])
            return
          }
          
          const params = {
            username: queryString.trim(),
            page: 0,
            size: 50,
            sortBy: 'id',
            sortDir: 'asc'
          }
          
          const response = await query_users_pagination(params)
          
          if (response.data && response.data.success) {
            const users = response.data.data?.content || []
            // 过滤掉 roleId 为 1 的超级管理员，并确保用户名包含查询字符串
            const filteredUsers = users.filter(user => {
              // 排除超级管理员
              if (user.roleId === 1) {
                return false
              }
              // 确保用户名匹配（不区分大小写）
              if (queryString && user.username) {
                return user.username.toLowerCase().includes(queryString.toLowerCase())
              }
              return true
            })
            
            cb(filteredUsers)
          } else {
            cb([])
          }
        } catch (error) {
          console.error('查询材料经理用户失败:', error)
          cb([])
        }
      },
      
      // 项目经理选择处理
      handleManagerSelect(item) {
        // 确保用户名正确设置（去除前后空格）
        this.projectForm.managerName = (item.username || '').trim()
        // 设置电话
        this.projectForm.managerContact = (item.phone || '').trim()
        
        // 清除该字段的验证错误，确保选择后验证状态正确
        this.$nextTick(() => {
          if (this.$refs.projectForm) {
            this.$refs.projectForm.clearValidate('managerName')
            // 如果电话也自动填充了，也清除电话字段的验证错误
            if (item.phone) {
              this.$refs.projectForm.clearValidate('managerContact')
            }
          }
        })
      },
      
      // 材料经理选择处理
      handleMaterialManagerSelect(item) {
        // 确保用户名正确设置（去除前后空格）
        this.projectForm.materialManagerName = (item.username || '').trim()
        // 设置电话
        this.projectForm.materialManagerContact = (item.phone || '').trim()
        
        // 清除该字段的验证错误，确保选择后验证状态正确
        this.$nextTick(() => {
          if (this.$refs.projectForm) {
            this.$refs.projectForm.clearValidate('materialManagerName')
            // 如果电话也自动填充了，也清除电话字段的验证错误
            if (item.phone) {
              this.$refs.projectForm.clearValidate('materialManagerContact')
            }
          }
        })
      },
      
      // 关联项目经理和项目
      async associateManagerWithProject(managerName, projectId) {
        try {
          if (!managerName || !projectId) {
            console.warn('项目经理姓名或项目ID为空，跳过关联')
            return
          }
          
          // 根据项目经理姓名查找用户
          const params = {
            username: managerName.trim(),
            page: 0,
            size: 10
          }
          
          const response = await query_users_pagination(params)
          
          if (response.data && response.data.success) {
            const users = response.data.data?.content || []
            // 精确匹配用户名（不区分大小写）
            const manager = users.find(user => 
              user.username && user.username.toLowerCase() === managerName.trim().toLowerCase()
            )
            
            if (manager) {
              // 获取用户当前的 projectIds
              const currentProjectIds = manager.projectIds || []
              
              // 如果项目ID不在列表中，则添加
              if (!currentProjectIds.includes(projectId)) {
                const updatedProjectIds = [...currentProjectIds, projectId]
                
                // 构建更新数据
                const updateData = {
                  id: manager.id,
                  username: manager.username,
                  phone: manager.phone,
                  roleId: manager.roleId,
                  unitId: manager.unitId,
                  projectIds: updatedProjectIds
                }
                
                // 如果有其他字段，也保留
                if (manager.signatureImagePath) {
                  updateData.signatureImagePath = manager.signatureImagePath
                }
                
                // 更新用户信息
                const updateResponse = await save_user(updateData)
                
                if (!updateResponse.data?.success) {
                  console.warn(`更新项目经理 ${managerName} 的项目关联失败:`, updateResponse.data?.message)
                }
              }
            } else {
              console.warn(`未找到项目经理用户: ${managerName}`)
            }
          } else {
            console.warn('查询项目经理用户失败:', response.data?.message)
          }
        } catch (error) {
          console.error('关联项目经理和项目失败:', error)
          // 不显示错误提示，避免影响项目保存的成功提示
        }
      },
      
      // 脱敏姓名
      maskName(name) {
        return maskNameUtil(name);
      },
      
      // 脱敏电话
      maskPhone(phone) {
        return maskPhoneUtil(phone);
      }
  }
}
</script>

<style lang="scss">
/* 全局对话框样式，确保对话框在页面中心 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 60px);   /* 限制最大高度 */
    
    .el-dialog__body {
      overflow-y: auto;               /* 内容过多时出现滚动条 */
      flex: 1;
    }
  }
}
</style>

<style lang="scss" scoped>
.projects-list-container {
  background-color: #fff;
  padding: 20px;
  min-height: calc(100vh - 120px);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  
     .page-header {
     display: flex;
     align-items: center;
     justify-content: space-between;
     margin-bottom: 20px;
     
     .blue-bar {
       width: 3px;
       background-color: #1890ff;
       height: 16px;
       margin-right: 8px;
     }
     
     .page-title {
       font-size: 16px;
       font-weight: 500;
       color: #333;
       margin: 0;
       flex: 1;
     }
     

   }
  
  .search-area {
    margin-bottom: 20px;
    
    .search-inputs {
      display: flex;
      flex-wrap: wrap;
      
      .search-item {
        margin-right: 15px;
        margin-bottom: 10px;
        width: 200px;
      }
      
      .search-buttons {
        display: flex;
        align-items: flex-start;
        
        .el-button {
          margin-right: 10px;
        }
      }
    }
  }
  
  .table-container {
    .el-table {
      margin-bottom: 20px;
    }
    
    .delete-btn {
      color: #f56c6c;
    }
  }
  
  .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .project-dialog {
    :deep(.el-dialog__header) {
      background-color: #f8f9fc;
      padding: 15px 20px;
      text-align: center;
    }
    
         .address-container {
       .region-selector {
         margin-bottom: 10px;
       }
       
       .detail-address {
         margin-bottom: 10px;
         
         .el-textarea__inner {
           border-radius: 2px;
         }
       }
       
       .address-preview {
         padding: 8px 12px;
         background-color: #f8f9fa;
         border-radius: 4px;
         border: 1px solid #e9ecef;
         
         .preview-label {
           color: #6c757d;
           font-size: 12px;
           margin-right: 8px;
         }
         
         .preview-content {
           color: #495057;
           font-size: 13px;
           font-weight: 500;
         }
       }
     }
    
    :deep(.el-dialog__title) {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
    
    .address-display {
      .region-info {
        .region-text {
          color: #303133;
          font-size: 14px;
        }
      }
      
      .address-text {
        color: #606266;
        font-size: 14px;
      }
    }
    
    :deep(.el-dialog__body) {
      padding: 20px;
    }
    
    :deep(.el-form-item__label) {
      font-weight: normal;
      color: #606266;
    }
    
    :deep(.el-input__inner) {
      border-radius: 2px;
    }
    
    :deep(.el-dialog__footer) {
      padding: 10px 20px 20px;
      text-align: center;
    }
    
    :deep(.el-dialog__headerbtn) {
      top: 15px;
    }
  }
  
  // 删除确认对话框样式
  :deep(.el-dialog) {
    border-radius: 4px;
    overflow: hidden;
  }
  
  // 用户自动完成选项样式
  .user-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .user-name {
      font-weight: 500;
      color: #303133;
    }
    
    .user-phone {
      font-size: 12px;
      color: #909399;
      margin-left: 10px;
    }
  }
}
</style>
